(function () {
  'use strict';

  angular
      .module('tf.retailer.Analytics')
      .controller('ExperimentDesignCtrl', ExperimentDesignCtrl)
      .directive('tfcExperimentDesign', tfcExperimentDesign);

  // @ngInject
  function ExperimentDesignCtrl() {
    var vm = this;

    vm.completeness = function () {
      var variations = _.get(vm, 'metrics.sessions.variations'),
          totalSessions = _.sum(variations, function (variation) {
        return variation.summary;
      });
      var completeness = totalSessions / vm.experiment.targetSessions;
      return Math.min(1, completeness);
    };
  }

  // @ngInject
  function tfcExperimentDesign() {
    return {
      restrict : 'E',
      controller : 'ExperimentDesignCtrl as vm',
      bindToController : true,
      templateUrl : 'Analytics/ExperimentDesign.tmpl.html',
      scope : {
        experiment : '=',
        metrics : '='
      }
    };
  }

})();
